import {Map} from 'immutable';
import {
  CLOSE_COMMUNITY_IN_ACTION_PHOTO_DIALOG,
  OPEN_COMMUNITY_IN_ACTION_PHOTO_DIALOG,
} from '../../actions';

const initialState = new Map({
  communityInActionPhotoDialogIsOpen: false,
  photoSrc: '',
});

export default function (state = initialState, action) {
  switch (action.type) {

    case OPEN_COMMUNITY_IN_ACTION_PHOTO_DIALOG:
      return state.withMutations(map => map.set('communityInActionPhotoDialogIsOpen', true)
                                           .set('photoSrc', action.payload.data));

    case CLOSE_COMMUNITY_IN_ACTION_PHOTO_DIALOG:
      return state.withMutations(map => map.set('communityInActionPhotoDialogIsOpen', false)
                                .set('photoSrc', ''));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/lessonDetail/reducers/pages/communityPhotoDialog.js